<template>
    <div>
        <b-modal id="campaign-add" title="Add a new campaign" :hide-footer="hideFooter">
            <form action="#" method="POST" class="createCampaign">
                <div class="form-group">
                    <label for="#cmpName">Campaign Name:</label>
                    <input class="form-control" type="text" id="cmpName" placeholder="Ex: Soccer" required="required" v-model="campaignName">
                </div>
                <div class="form-group">
                    <label for="#cmpCode">Campaign Code:</label>
                    <input class="form-control" type="text" id="cmpCode" placeholder="Ex: 1" required v-model="campaignCode">
                </div>
                <div class="form-group">
                    <label for="#cmpDescription">Campaign Description:</label>
                    <textarea class="form-control" id="cmpDescription" v-model="campaignDescription"></textarea>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveCampaign">Save</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
import collect from 'collect.js'

export default {
  methods: {
    saveCampaign () {
      if (this.campaignDescription && this.campaignCode && this.campaignName) {
        this.$http.post(`${this.$api_url}/campaign/create`, { name: this.campaignName, code: this.campaignCode, description: this.campaignDescription }).then((success, error) => {
          if (success) {
            Bus.$emit('reloadCampaigns', success.data)
            this.$bvModal.hide('campaign-add')
            this.campaignDescription = ''
            this.campaignName = ''
            this.campaignCode = ''
          }
          if (error) {
            this.$bvModal.hide('campaign-add')
            alert('Duplicate campaign')
          }
        })
      }
    },
    getMaxCampaignCode () {
      this.$http.get(`${this.$api_url}/campaigns/all`).then((campaigns) => {
        if (campaigns) {
          campaigns = campaigns.data
          let maxCode = collect(campaigns).max('code') || 0
          maxCode = maxCode === '-Infinity' ? 0 : maxCode
          this.campaignCode = maxCode + 1
        } else {
          this.campaignCode = 1
        }
      })
    }
  },
  created () {
    Bus.$on('modalCampaignsOpened', (data) => {
      this.getMaxCampaignCode()
    })
  },
  beforeDestroy () {
    Bus.$off('modalCampaignsOpened')
  },
  data () {
    return {
      campaignName: '',
      campaignCode: '',
      campaignDescription: '',
      hideFooter: true
    }
  }
}
</script>
<style scoped>

</style>
